import React, { useState, useEffect } from "react";
import "./department.css";
import Component from "../../Components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "../../utils/strings";

const Department = () => {
  const [selectedView, setSelectedView] = useState("doctorSpecialization");
  const [departmentToEdit, setDepartmentToEdit] = useState(null);

  const nav = useNavigate();
  const privilege = useSelector((state) => state.verifyType.privilege);
  useEffect(() => {
    switch (true) {
      case privilege.hasDepartmentRight:
        nav(strings.navigation.department);
        break;
      case privilege.hasTNCright:
        nav(strings.navigation.termsCondition);
        break;
      case privilege.hasPatientProfileRight:
        nav(strings.navigation.patientProfile);
        break;
      case privilege.hasNationalIdRight:
        nav(strings.navigation.nationalID);
        break;
      case privilege.hasArticleRight:
        nav(strings.navigation.healthArticle);
        break;
    }
  }, [privilege]);

  const handleDepartmentSelect = (department) => {
    setDepartmentToEdit(department);
    setSelectedView("editDepartment");
  };
  return (
    <div className="department-screen">
      {selectedView === "doctorSpecialization" && <Component.DoctorSpecialization setSelectedView={setSelectedView} onDepartmentSelect={handleDepartmentSelect} />}
      {selectedView === "addSpeciality" && <Component.AddSpeciality setSelectedView={setSelectedView} />}
      {selectedView === "editDepartment" && <Component.EditDepartment setSelectedView={setSelectedView} department={departmentToEdit} isEdit />}
    </div>
  );
};

export default Department;
